export default "__VITE_ASSET__CppczyLq__"